import { render, staticRenderFns } from "./riepilogo.vue?vue&type=template&id=34bb7e67"
import script from "./riepilogo.vue?vue&type=script&lang=js"
export * from "./riepilogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bb7e67')) {
      api.createRecord('34bb7e67', component.options)
    } else {
      api.reload('34bb7e67', component.options)
    }
    module.hot.accept("./riepilogo.vue?vue&type=template&id=34bb7e67", function () {
      api.rerender('34bb7e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/riepilogo.vue"
export default component.exports